/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Age_MinutesInputs */

const en_age_minutes = /** @type {(inputs: Age_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}m`)
};

const de_age_minutes = /** @type {(inputs: Age_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} Min`)
};

/**
* | output |
* | --- |
* | "{n}m" |
*
* @param {Age_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const age_minutes = /** @type {((inputs: Age_MinutesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Age_MinutesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_age_minutes(inputs)
	return en_age_minutes(inputs)
});